var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_4835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 50.8998C21.6 50.8998 13.2 42.4998 13.2 32.0998C13.2 21.6998 21.6 13.2998 32 13.2998C42.4 13.2998 50.8 21.6998 50.8 32.0998C50.8 42.4998 42.4 50.8998 32 50.8998ZM32 19.4998C25.1 19.4998 19.4 25.0998 19.4 32.0998C19.4 38.9998 25 44.6998 32 44.6998C38.9 44.6998 44.6 39.0998 44.6 32.0998C44.6 25.1998 38.9 19.4998 32 19.4998Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8 35.2H58.2C56.5 35.2 55.1 33.8 55.1 32.1C55.1 30.4 56.5 29 58.2 29H60.8C62.5 29 63.9 30.4 63.9 32.1C63.9 33.8 62.5 35.2 60.8 35.2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 9.1002C30.3 9.1002 28.9 7.7002 28.9 6.0002V3.3002C28.9 1.6002 30.3 0.200195 32 0.200195C33.7 0.200195 35.1 1.6002 35.1 3.3002V5.9002C35.1 7.7002 33.7 9.1002 32 9.1002Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 64.0002C30.3 64.0002 28.9 62.6002 28.9 60.9002V58.3002C28.9 56.6002 30.3 55.2002 32 55.2002C33.7 55.2002 35.1 56.6002 35.1 58.3002V60.9002C35.1 62.6002 33.7 64.0002 32 64.0002Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9 56.1999C52.1 56.1999 51.3 55.8999 50.7 55.2999L48.1 52.6999C46.9 51.4999 46.9 49.4999 48.1 48.2999C49.3 47.0999 51.3 47.0999 52.5 48.2999L55.1 50.8999C56.3 52.0999 56.3 54.0999 55.1 55.2999C54.5 55.7999 53.7 56.1999 52.9 56.1999Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3 16.9001C49.5 16.9001 48.7 16.6001 48.1 16.0001C46.9 14.8001 46.9 12.8001 48.1 11.6001L50.7 9.0001C51.9 7.8001 53.9 7.8001 55.1 9.0001C56.3 10.2001 56.3 12.2001 55.1 13.4001L52.5 16.0001C51.9 16.6001 51.1 16.9001 50.3 16.9001Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1 56.1999C10.3 56.1999 9.5 55.8999 8.9 55.2999C7.7 54.0999 7.7 52.0999 8.9 50.8999L11.5 48.2999C12.7 47.0999 14.7 47.0999 15.9 48.2999C17.1 49.4999 17.1 51.4999 15.9 52.6999L13.3 55.2999C12.7 55.7999 11.9 56.1999 11.1 56.1999Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7 16.9001C12.9 16.9001 12.1 16.6001 11.5 16.0001L8.9 13.4001C7.7 12.2001 7.7 10.2001 8.9 9.0001C10.1 7.8001 12.1 7.8001 13.3 9.0001L15.9 11.6001C17.1 12.8001 17.1 14.8001 15.9 16.0001C15.3 16.6001 14.5 16.9001 13.7 16.9001Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79998 35.2H3.19998C1.49998 35.2 0.0999756 33.8 0.0999756 32.1C0.0999756 30.4 1.49998 29 3.19998 29H5.79998C7.59998 29 8.99998 30.4 8.99998 32.1C8.99998 33.8 7.59998 35.2 5.79998 35.2Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_4835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonne);
export default __webpack_public_path__ + "static/media/sonne.71c0d4bae4cec3bf82ea2a48bea23dd2.svg";
export { ForwardRef as ReactComponent };